import { ElectronApi } from '@/services/electron.api';
import { RemoteLibsService } from '@/services/remote-libs.service';

export default async function (
  imgPath: string,
  isRotate: boolean,
  isN65C = false
): Promise<Buffer | undefined> {
  const path = ElectronApi.path;
  const fs = ElectronApi.fs;
  const service = new RemoteLibsService();
  const ezipFile = await service.getLibFilename('ezip');
  const tmpPath = await ElectronApi.getPath('temp');
  if (!path || !ezipFile || !fs || !tmpPath) return;

  await ElectronApi.execFile(ezipFile, [
    '-convert',
    imgPath,
    '-pal_support',
    '1',
    '-grey_support',
    '-binfile',
    isRotate ? '1' : '2',
    isN65C ? '-dither' : '',
    isN65C ? '0' : '',
    '-mi',
    '-outdir',
    tmpPath
  ]);
  const filename = path.basename(imgPath).split('.').slice(0, -1).join('.');
  const bin = await fs.promises.readFile(path.join(tmpPath, `${filename}.bin`));
  return bin;
}
